import { lazy } from 'react'
import { Outlet } from 'react-router-dom'

const Check = lazy(() => import('@/pages/Check'))
const Publish = lazy(() => import('@/pages/Publish'))
const TeaHome = lazy(() => import('@/pages/TeaHome'))
const PublishConfig = lazy(() => import('@/pages/Publish/Config'))
const OverviewAnalyse = lazy(() => import('@/pages/CheckAnalyse'))
const PersonAnswer = lazy(() => import('@/pages/PersonDetail'))

const teaRoute = [
	{ path: 'home', auth: true, element: <TeaHome />, title: '首页', breadcrumb: true },
	{
		path: 'publish',
		auth: true,
		element: <Outlet />,
		title: '布置',
		breadcrumb: true,
		children: [
			{ path: '', auth: true, element: <Publish />, breadcrumb: false, title: '检查' },
			{ path: 'config', auth: true, element: <PublishConfig />, breadcrumb: true, title: '布置设置' }
		]
	},
	{
		path: 'check',
		auth: true,
		element: <Outlet />,
		title: '检查',
		breadcrumb: true,
		children: [
			{ path: '', element: <Check />, title: '', breadcrumb: false },
			{
				path: 'overview',
				element: <Outlet />,
				title: '听说套卷',
				breadcrumb: true,
				children: [
					{ path: '', element: <OverviewAnalyse />, title: '', breadcrumb: false },
					{ path: 'personHomework', element: <PersonAnswer />, title: '个人作答详情', breadcrumb: true }
				]
			}
		]
	}
]

export default teaRoute
